import * as React from 'react';

import classnames from 'classnames';

import {exhaustivenessCheck} from 'nutshell-core/typing/exhaustiveness-check';

import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

import type {EntitySummaryStatus} from 'nutshell-graphql-types';

import styles from './transcription-section.module.css';

type Props = {
    summary?: string | null | undefined;
    summaryStatus?: EntitySummaryStatus | null | undefined;
    canTranscribe: boolean;
};

export function SummarizeSection(props: Props) {
    let body;
    if (props.canTranscribe) {
        if (props.summaryStatus === 'ERRORED') {
            body = (
                <Body color='error' size='small'>
                    There was an error generating the summary.
                </Body>
            );
        } else if (props.summaryStatus === 'COMPLETE') {
            body = (
                <Body size='small' maintainLineBreaks={true} preventCopy={true}>
                    {props.summary}
                </Body>
            );
        } else if (props.summaryStatus === 'LOADING' || props.summaryStatus == null) {
            body = (
                <>
                    <Body size='small'>Summarization in progress…</Body>
                    <LoadingText width={480} />
                </>
            );
        } else {
            exhaustivenessCheck(props.summaryStatus);
        }
    } else {
        body = (
            <div className='border br-3 px-16 py-8'>
                <Body size='small'>This call can not be summarized without a transcription.</Body>
            </div>
        );
    }

    return (
        <div
            className={classnames(styles['section-wrapper'], {
                [styles.disabled]: !props.canTranscribe,
            })}
        >
            <div className='flex align-center gap-8'>
                <AiSparkleNewIcon size={12} alignCenter={true} wrapWithDiv={false} />
                <Body size='mini' isBold={true}>
                    AI Summary
                </Body>
            </div>
            {body}
        </div>
    );
}
